import {
    Component,
    OnInit,
    ViewContainerRef,
    ViewChild,
    TemplateRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';

import { Router, Event as NavigationEvent } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { Location } from '@angular/common';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { ProviderContext } from '../../data/Entities';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalDialogService } from 'ngx-modal-dialog';
import { SimpleModalComponent } from 'ngx-modal-dialog';

declare var appConfig: any;

@Component({
    selector: 'order_detail',
    templateUrl: 'templates/get/Order/order_detail',
})
export class OrderDetailFrm implements OnInit {
    PCODE: string = 'ORDER';
    public submitted: boolean = false;

    public errstr: string;
    public statusEdit: boolean = false;
    public deliveryDayEdit: boolean = false;
    public deliveryTimeSlotEdit: boolean = false;
    public entity: any = {};
    public MediaServicesUrl: string;
    public categoryList: [] = [];
    public productList: [] = [];
    public searchText: string;
    public onlySelected: boolean = false;

    public modalRef: BsModalRef;

    @ViewChild('orderertemplate')
    private ordererTemplateRef: TemplateRef<any>;

    constructor(
        public siteServices: SiteServices,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: BsModalService,
        public modalService2: ModalDialogService,
        public location: Location,
        public viewRef: ViewContainerRef
    ) {
        this.MediaServicesUrl = appConfig.MediaServicesUrl;
    }

    refresh(id: any) {
        if (id && id != '0') {
            this.siteServices.provider_GetDataByID(
                this.PCODE,
                id,
                null,
                (data) => {
                    this.entity = data.TagObject;
                }
            );
        }
    }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            if (params.id) {
                let id = params.id;
                if (id && id != '0') {
                    this.refresh(id);
                }
            }
        });
    }

    save(frm) {
        this.submitted = true;
        if (!frm.valid) {
            this.siteServices.error('Hibás kitöltés!');
            return;
        }

        this.siteServices.provider_Save(this.PCODE, this.entity, (data) => {
            this.entity = data.TagObject;

            this.siteServices.onChangeDetail.next(this.entity);
            this.refresh(this.entity.CategoryBlockID);
            setTimeout((x) => this.siteServices.success('OK'), 200);
        });
    }

    stEdit() {
        console.log('STEDIT');
        this.statusEdit = true;
    }

    saveStatus() {
        this.siteServices.provider_Execute(
            this.PCODE,
            'SAVESTATUS',
            this.entity,
            (data) => {
                this.entity = data.TagObject;
                this.statusEdit = false;
                this.siteServices.onChangeDetail.next(this.entity);
                setTimeout((x) => this.siteServices.success('OK'), 200);
            }
        );
    }

    saveDelivery() {
        this.siteServices.provider_Execute(
            this.PCODE,
            'SAVEDELIVERY',
            this.entity,
            (data) => {
                this.entity = data.TagObject;
                this.statusEdit = false;
                this.siteServices.onChangeDetail.next(this.entity);
                setTimeout((x) => this.siteServices.success('OK'), 200);
            }
        );
    }

    deleteItem(orderItem: any) {
        this.sure(this.viewRef, (x) => {
            this.siteServices.provider_Execute(
                this.PCODE,
                'DELETEORDERITEM',
                orderItem,
                (x) => {
                    this.siteServices.onChangeDetail.next(this.entity);
                    this.entity = x.TagObject;
                    this.siteServices.success('Törlés OK');
                }
            );
        }); //sure
    }

    saveItem(orderItem: any) {
        this.siteServices.provider_Execute(
            this.PCODE,
            'SAVEORDERITEM',
            orderItem,
            (x) => {
                this.siteServices.onChangeDetail.next(this.entity);
                this.entity = x.TagObject;
                this.siteServices.success('Mentés OK');
            }
        );
    }

    public sure(viewRef: ViewContainerRef, clbFunc: Function) {
        const actionButtons = [
            {
                text: 'igen',
                onAction: () => {
                    clbFunc();
                    return true;
                },
            },
            {
                text: 'nem',
                onAction: () => {
                    return true;
                },
            },
        ];

        this.modalService2.openDialog(viewRef, {
            title: 'Biztos vagy benne?',
            childComponent: SimpleModalComponent,
            actionButtons: actionButtons,
            data: { text: 'A termék törlödik a rendelésből' },
        });
    }

    editOrderer() {
        this.modalRef = this.modalService.show(this.ordererTemplateRef, {
            class: 'modal-lg',
        });
    }

    saveDeliveryDay() {
        this.siteServices.provider_Execute(
            this.PCODE,
            'SAVEDELIVERYDAY',
            this.entity,
            (data) => {
                this.entity = data.TagObject;
                this.deliveryDayEdit = false;
                this.siteServices.onChangeDetail.next(this.entity);
                setTimeout((x) => this.siteServices.success('OK'), 200);
            }
        );
    }

    saveDeliveryTimeSlot() {
        this.siteServices.provider_Execute(
            this.PCODE,
            'SAVEDELIVERYTIMESLOT',
            this.entity,
            (data) => {
                this.entity = data.TagObject;
                this.deliveryTimeSlotEdit = false;
                this.siteServices.onChangeDetail.next(this.entity);
                setTimeout((x) => this.siteServices.success('OK'), 200);
            }
        );
    }

    saveOrderer() {
        this.modalRef.hide();

        this.siteServices.provider_Execute(
            this.PCODE,
            'SAVEORDERER',
            this.entity,
            (data) => {
                this.entity = data.TagObject;
                this.siteServices.onChangeDetail.next(this.entity);
                setTimeout((x) => this.siteServices.success('OK'), 200);
            }
        );
    }
}
